import { Controller } from "@hotwired/stimulus"

// Controller Stimulus pour améliorer l'UX des inputs date
// Permet d'ouvrir le datepicker natif en cliquant n'importe où dans l'input
export default class extends Controller {
  static targets = ["input"]

  connect() {
    const input = this.hasInputTarget ? this.inputTarget : this.element
    if (!["date", "datetime-local", "time"].includes(input.type)) return

    this.input = input
    this.boundOpenPicker = this.openPicker.bind(this)
    input.addEventListener("click", this.boundOpenPicker)
    input.addEventListener("focus", this.boundOpenPicker)
  }

  disconnect() {
    if (!this.input || !this.boundOpenPicker) return
    this.input.removeEventListener("click", this.boundOpenPicker)
    this.input.removeEventListener("focus", this.boundOpenPicker)
  }

  openPicker(event) {
    const input = event.currentTarget

    // Utiliser showPicker() si disponible (API moderne des navigateurs)
    if (input.showPicker && typeof input.showPicker === "function") {
      try {
        input.showPicker()
      } catch (error) {
        // Certains navigateurs peuvent échouer silencieusement
        console.debug("showPicker() not available or failed:", error)
      }
    }
  }
}
